import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { OrdersSettingsInterface } from '@shared/components/trading/widgets/orders-widget/core/interfaces/orders-settings.interface'
import { OrdersComponent } from '@shared/components/trading/orders/orders.component'

@Component({
	selector: 'app-orders-widget',
	templateUrl: './orders-widget.component.html',
	styleUrl: './orders-widget.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [OrdersComponent],
})
export class OrdersWidgetComponent {
	public widget: InputSignal<WidgetInterface<OrdersSettingsInterface> | null> =
		input.required<WidgetInterface<OrdersSettingsInterface> | null>()
}
